import * as Lucide from "lucide-react";

const CityBenefits = ({ benefits, cityName }) => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="city-benefits-section">
      <div className="container-tm">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="overline">Conciergerie Airbnb · {cityName}</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            C'est possible avec
            <span className="italic text-gold"> notre conciergerie Airbnb à {cityName}</span>.
          </h2>
          <p className="mt-6 font-sans text-base md:text-lg text-ink/65 leading-relaxed">
            Vous profiterez d'un accompagnement personnalisé et de services tout compris dans nos formules : préparation du logement, photos professionnelles, suivi des réservations, ménage, échanges avec les voyageurs, kit d'accueil (Shampooing, gel douche, papier toilette, produit vaisselle, éponge, sac-poubelle, petit sac pour la salle de bain). Terre et Mer « booste » vos réservations en passant par Airbnb, Booking.com, Vrbo et Tripadvisor.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {benefits.map((b, i) => {
            const Icon = Lucide[b.icon] || Lucide.Sparkles;
            return (
              <div
                key={b.title}
                data-testid={`city-benefit-${i}`}
                className="group card-modern p-8 lg:p-10 text-center"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gold/10 group-hover:bg-gold transition-colors duration-500 mb-6">
                  <Icon size={24} strokeWidth={1.6} className="text-gold group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-ink mb-4 leading-tight">
                  {b.title}
                </h3>
                <p className="font-sans text-sm md:text-base text-ink/65 leading-relaxed">
                  {b.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CityBenefits;
